class JSBridge {

    constructor() {
        this.authToken = '';
        this.appVersion = '';
    }

    async generateAuthToken() {

        let { authToken } = this;
        let isTokenSet = false;

        window.onReceiveAuth = function(token) {
            authToken = token;
            isTokenSet = true;
        };

        function triggerNativeAuth(nativeFunction) {
            return new Promise(resolve => {
                let timeout = 10000;

                nativeFunction;
                const myInterval = setInterval(() => {
                    timeout = timeout - 100;
                    if (timeout % 1000 === 0) nativeFunction;
                    if (isTokenSet || timeout === 0) {
                        clearInterval(myInterval);
                        resolve();
                    }
                }, 100);
            });
        }

        try {
            if (/iPhone|iPad|iPod/i.test(navigator.userAgent)) {
                await triggerNativeAuth(webkit.messageHandlers.requestAuth.postMessage({}));
                this.authToken = authToken;
                return this.authToken;
            }
            else if (/Android/i.test(navigator.userAgent)) {
                await triggerNativeAuth(AuthJsHandler.requestAuth());
                this.authToken = authToken;
                return this.authToken;
            }
        } catch {
            return '';
        }
    }

    async generateAppVersion() {

        let { appVersion } = this;
        let isAppVersionSet = false;

        window.onReceiveAppVersion = function(version) {
            appVersion = version;
            isAppVersionSet = true;
        };

        function triggerNativeAppVersion(nativeFunction) {
            return new Promise(resolve => {
                let timeout = 10000;

                nativeFunction;
                const myInterval = setInterval(() => {
                    timeout = timeout - 100;
                    if (timeout % 1000 === 0) nativeFunction;
                    if (isAppVersionSet || timeout === 0) {
                        clearInterval(myInterval);
                        resolve();
                    }
                }, 100);
            });
        }

        try {
            if (/iPhone|iPad|iPod/i.test(navigator.userAgent)) {
                await triggerNativeAppVersion(webkit.messageHandlers.getAppVersion.postMessage({}));
                this.appVersion = appVersion;
                return this.appVersion;
            }
            else if (/Android/i.test(navigator.userAgent)) {
                await triggerNativeAppVersion(AndroidJsHandler.getAppVersion());
                this.appVersion = appVersion;
                return this.appVersion;
            }
        } catch {
            return '1.0.0';
        }
    }

    async closeWebView() {
        try {
            if (/iPhone|iPad|iPod/i.test(navigator.userAgent)) {
                webkit.messageHandlers.closeWebView.postMessage({});
            }
            else if (/Android/i.test(navigator.userAgent)) {
                AndroidJsHandler.closeWebView();
            }
        } catch (err) {
            console.info('Only on supported on Mobile');
        }
    }

    async hideNativeNavigationBar() {
        try {
            if (/iPhone|iPad|iPod/i.test(navigator.userAgent)) {
                webkit.messageHandlers.hideNativeNavigationBar.postMessage({});
            }
            else if (/Android/i.test(navigator.userAgent)) {
                AndroidJsHandler.hideNativeNavigationBar();
            }
        } catch (err) {
            console.info('Only on supported on Mobile');
        }
    }

    async leanplumWebviewTracker(eventName, eventParams) {
        try {
            if (/iPhone|iPad|iPod/i.test(navigator.userAgent)) {
                webkit.messageHandlers.leanplum.postMessage(`event+${eventName}+${JSON.stringify(eventParams)}`);
            }
            else if (/Android/i.test(navigator.userAgent)) {
                InternalTrackerJsHandler.leanplumWebview('event', eventName, JSON.stringify(eventParams));
            }
        } catch (err) {
            console.info('Leanplum is only supported on Mobile.');
        }
    }
}

export default JSBridge;
